import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("@/views/index.vue")
  },
  {
    path: "/software",
    name: "software",
    component: () => import("@/components/index/software.vue")
  },
  {
    path: "/hardware",
    name: "hardware",
    component: () => import("@/components/index/hardware.vue")
  },
  {
    path: "/programme",
    name: "programme",
    component: () => import("@/components/index/programme.vue")
  },
  {
    path: "/scenic",
    name: "scenic",
    component: () => import("@/components/index/scenic.vue")
  },
  {
    path: "/customer",
    name: "customer",
    component: () => import("@/components/index/customer.vue")
  },
  {
    path: "/problem",
    name: "problem",
    component: () => import("@/components/problem/index.vue")
  },
  {
    path: "/set",
    name: "set",
    component: () => import("@/components/problem/set.vue")
  },
  {
    path: "/Third",
    name: "Third",
    component: () => import("@/components/problem/Third.vue")
  },
  {
    path: "/Third1",
    name: "Third1",
    component: () => import("@/components/problem/Third1.vue")
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/components/problem/about.vue")
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login.vue")
  },
  {
    path: "/list",
    name: "list",
    component: () => import("@/components/problem/list.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
export default router;
